<template>
  <div
    class="
      flex
      flex-col
      h-full
      px-4
      w-full
    "
  >
    <div class="
      flex
      flex-col
      items-center
      justify-center
      w-full
    ">
      <h1 v-if="company" class="mt-[84px] text-black text-3xl sm:hidden sm:mt-7">
        在好彙訂加入<span class="text-secondary-500">{{ company }}</span>
      </h1>
      <form class="
        bg-white
        box-shadow
        flex
        flex-col
        items-center
        justify-center
        my-10
        pb-6
        pt-2
        px-6
        w-[424px]
        rounded-lg
        sm:my-14
        sm:w-full
      ">
        <h1 class="text-black font-light text-3xl mb-4">
          設定密碼
        </h1>
        <span v-if="company" class="text-sm text-center text-gray-500 mb-16 sm:mb-7">
          設定密碼以加入{{ company }}
        </span>
        <div class="w-full mb-12">
          <w-input
            v-model="form.password"
            :message="getPasswordMsg"
            :show-error="hasErrorMsgs('password')"
            :show-success="
              !setPwdValidator$.form.password.invalid && setPwdValidator$.form.password.$dirty
            "
            class="w-full"
            password-reveal
            placeholder="設定新密碼"
            type="password"
            @blur="setPwdValidator$.form.password.$touch()"
          />
          <w-input
            v-model="form.confirmPassword"
            :message="getErrorMsgs('confirmPassword')"
            :show-error="hasErrorMsgs('confirmPassword')"
            :show-success="
              !setPwdValidator$.form.confirmPassword.invalid
              && setPwdValidator$.form.confirmPassword.$dirty
            "
            class="w-full"
            password-reveal
            placeholder="確認新密碼"
            type="password"
            @blur="setPwdValidator$.form.confirmPassword.$touch()"
          />
          <label class="flex">
            <t-checkbox v-model="form.subscribed_weiby" class="mr-2 mt-1" name="subscribe" />
            <span class="text-black">
              是的，我願意接收好彙訂訊息以獲得最新活動等資訊
            </span>
          </label>
        </div>
        <w-button
          :disabled="
            settingPassword || (setPwdValidator$.form.$invalid && setPwdValidator$.form.$dirty)
          "
          :loading="settingPassword"
          :variant="setPwdValidator$.form.$invalid && !$breakpoints.sm ? 'outline' : null"
          class="mb-2 w-full"
          @click="confirm"
        >
          加入
        </w-button>
        <p class="sm:text-sm text-black text-center">
        點擊加入即表示您同意「好彙訂」
        <a
          alt="Term of Service"
          class="sm:text-sm text-blue-400"
          href="https://www.takeorder.tw/terms-of-service"
          target="_blank"
        >
          使用條款
        </a>
        及
        <a
          alt="Privacy and Policy"
          class="sm:text-sm text-blue-400"
          href="https://www.takeorder.tw/privacy-and-policy"
          target="_blank"
        >
          隱私權政策
        </a>
      </p>
      </form>
    </div>
    <w-loading v-if="checkingToken" />
  </div>
</template>

<script>
import SetPassword from './SetPassword';

export default SetPassword;
</script>

<style lang="scss" scoped>
@import 'SetPassword';
</style>
